// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Background from '../assets/images/login-bg.png';
import Card from '../components/Card';
import styled from 'styled-components';
import Footer from './MainLayout/Footer';
import Header from './MainLayout/Header';
import { FormattedMessage } from 'react-intl';
import LanguagePopup, { S as LanguagePopupStyle } from './MainLayout/Header/LanguagePopup';

const SS = {
  Container: styled.div`
    position: relative;
  `,
  SelectedContainer: styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
  `,
  Text: styled.p`
    font-size: 12px;
    line-height: 17px;
    color: #666666;
  `,
  Triangle: styled.div`
    position: absolute;
    left: calc(100% + 5px);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 3.5px 0 3.5px;
    border-color: #666666 transparent transparent transparent;
  `,
  LanguagePopup: styled(LanguagePopup)`
    position: absolute;
    left: 50%;
    top: -13px;
    transform: translateX(-50%);
    min-width: 112px;

    ${LanguagePopupStyle.Item} {
      font-size: 12px;
      line-height: 17px;
    }
  `,
}

const LanguageSwitch: React.FC<React.ComponentPropsWithRef<'div'>> = (props) => {
  const [isPopupShow, setPopupShow] = useState(false);

  const togglePopup = useCallback(() => {
    setPopupShow(!isPopupShow)
  }, [isPopupShow]);

  const closePopup = useCallback(() => {
    setPopupShow(false);
  }, []);

  useEffect(() => {
    if (isPopupShow) {
      window.addEventListener('click', closePopup);
    }

    return () => {
      window.removeEventListener('click', closePopup);
    }
  }, [isPopupShow, closePopup]);

  return (
    <SS.Container {...props}>
      <SS.SelectedContainer onClick={togglePopup}>
        <SS.Text><FormattedMessage id="Language" /></SS.Text>
        <SS.Triangle />
      </SS.SelectedContainer>
      {isPopupShow && (<SS.LanguagePopup closePopup={closePopup} />)}
    </SS.Container>
  )
}

export const S = {
  Container: styled.div`
    padding-top: 80px;
    padding-bottom: 80px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${Background});
    overflow: auto;
  `,
  Header: styled(Header)`
  `,
  CardContainer: styled.div`
    margin: auto;
  `,
  Card: styled(Card)`
    width: 448px;
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  `,
  ContentContainer: styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
  `,
  LanguageSwitch: styled(LanguageSwitch)`
    position: absolute;
    right: 22px;
    top: 10px;
  `,
  PageContainer: styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-grow: 1;
    padding: 13px 41px 20px 41px;
    background: #FFFFFF;
    border-radius: 4px;
  `,
  InformationContainer: styled.div`
    text-align: center;
    font-size: 12px;
    line-height: 17px;
    color: #666666;
    margin-top: 6px;
  `,
  ErrorLogin: styled.div<{ hasError: boolean }>`
    padding: 3px 0 4px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #FFFFFF;
    text-align: center;
    ${props => props.hasError ? `
    background: #FE4747;
    border-radius: 4px 4px 0px 0px;
    ` : ''}
  `,
  Footer: styled(Footer)`
    && {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
   }
  `
}
interface LoginLayout extends React.ComponentPropsWithRef<'div'> {
  information?: string | JSX.Element;
  errorLogin?: string | undefined;
}

const LoginLayout: React.FC<LoginLayout> = ({ information, errorLogin, ...props }) => {
  const html = useMemo(() => {
    return { __html: errorLogin || '' }
  }, [errorLogin]);

  return (
    <S.Container {...props}>
      <S.CardContainer>
        <S.Card>
          <S.ErrorLogin hasError={!!errorLogin} dangerouslySetInnerHTML={html} />
          <S.ContentContainer>
            <S.LanguageSwitch />
            <S.PageContainer>
              {props.children}
            </S.PageContainer>
          </S.ContentContainer>
        </S.Card>
        {information && <S.InformationContainer>{information}</S.InformationContainer>}
      </S.CardContainer>
      <S.Footer/>
    </S.Container>
  )
}

export { LoginLayout as default }
